module.exports = __webpack_public_path__ + "img/tav-guvenlik-desktop.58e75795.jpg";